export default {
  name: "Paginator",
  props: ["pages", "current", "limit", "isSearchNow"],
  data() {
    return {
      arPages: [],
    }
  },
  watch: {},
  mounted() {
    this.buildChain()
  },
  methods: {
    buildChain() {
      if (this.pages > 1) {
        this.arPages = []
        let pageLimit = 10
        let upperLimit, lowerLimit
        lowerLimit = upperLimit = Math.min(this.current, this.pages)
        for (var b = 1; b < pageLimit && b < this.pages; ) {
          if (lowerLimit > 1) {
            lowerLimit--
            b++
          }
          if (b < pageLimit && upperLimit < this.pages) {
            upperLimit++
            b++
          }
        }

        for (let i = lowerLimit; i <= upperLimit; i++) {
          this.arPages.push(i)
        }
      }
    },
    goTo(page) {
      try {
        this.$parent.changePage(page)
      } catch (e) {
        console.error(e)
      }
    },
    onForward() {
      if (this.current < this.pages) {
        this.goTo(Number(this.current) + 1)
      }
    },
    onBackward() {
      if (this.current > 1) {
        this.goTo(Number(this.current) - 1)
      }
    },
  },
  template:
    '<ul v-if="!isSearchNow" class="mpaginator">' +
    '<li v-if="current != 1" @click="onBackward" class="mpaginator__link"><img src="/assets/images/manager-paginator-arrow.svg"></li>' +
    '<li class="mpaginator__link" v-for="page in arPages" v-bind:class="{ \'active\': page == current}" @click="goTo(page)">{{page}}</li>' +
    '<li v-if="current != pages" @click="onForward" class="mpaginator__link forward"><img src="/assets/images/manager-paginator-arrow.svg"></li></ul>',
}
